/**
 * Purpose:
 *   Loads the flags sprite SVG into the DOM so that <use> elements can reference it.
 *   This component should be included once in the app layout.
 *
 * Notes:
 *   - SVG sprites need to be in the DOM for <use> elements to work
 *   - This component loads the sprite and hides it
 */

'use client';

import { useEffect } from 'react';

export function FlagSpriteLoader() {
  useEffect(() => {
    // Check if sprite is already loaded
    const existingSprite = document.getElementById('flags-sprite');
    if (existingSprite) {
      return;
    }

    // Load the sprite SVG
    fetch('/flags/flags-sprite.svg')
      .then((response) => response.text())
      .then((svgText) => {
        // Create a container for the sprite
        const container = document.createElement('div');
        container.id = 'flags-sprite-container';
        container.style.display = 'none';
        container.innerHTML = svgText;
        document.body.appendChild(container);
      })
      .catch((error) => {
        console.error('Failed to load flags sprite:', error);
      });
  }, []);

  return null;
}
